import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export default function getQuotesContextConfiguration() {
  return new NetworkRequestConfiguration({
    endpoint: 'renters/contexts/quotes_context',
    method: NetworkRequestConfiguration.Methods.GET,
  });
}
